import { debounce } from 'underscore';

import { detectTouchDevice } from './screen';
import { initSliders, resetSliders } from './sliders';
import { initCGAAccordions, resetCGAAccordions } from './accordions';
import initCGA2026Navigations from './top-navigations';
import { initCGAPanelColumns } from './panel-columns';
import { initCGAFAQShowMores } from './faqs';
import { initProvincialProfiles } from './provincial-profiles';

cga2026_script_vars = cga2026_script_vars || {};

cga2026_script_vars.current_width = window.innerWidth;
cga2026_script_vars.page_initialized = false;

const scrollToPos = ( pos ) => {
	window.scrollTo({
		top: pos,
		left: 0,
		behavior: 'smooth'
	});
};

const deleteEmptyP = () => {
	document.querySelectorAll( 'p' ).forEach( p => {
		if ( !p.innerHTML.trim() ) {
			p.remove();
		}
	});
};

const monitorGotoTop = () => {
	const gototop = document.querySelector( '#return-to-top-container' );
	if ( gototop === null ) {
		return;
	}

	if ( window.scrollY > 500 ) {
		gototop.classList.add( 'active' );
	} else {
		gototop.classList.remove( 'active' );
	}
};

const initGotoTop = () => {
	const gototop = document.querySelector( '#return-to-top-container' );
	if ( gototop !== null ) {
		gototop.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			scrollToPos( 0 );
		});
	}
};

const doWhenScrolling = () => {
	monitorGotoTop();
};

const doWhenOrientationChanged = () => {
	if ( cga2026_script_vars.page_initialized ) {
		const current_width = window.innerWidth;
		if ( current_width === cga2026_script_vars.current_width ) {
			return;
		}
	}

	if ( typeof window.cga2026_swiper_sliders === 'undefined' ) {
		window.cga2026_swiper_sliders = {};
	}

	resetSliders();
	resetCGAAccordions();

	initSliders();
	initCGAAccordions();
	initGotoTop();
	initCGA2026Navigations();
	initCGAPanelColumns();
	initCGAFAQShowMores();
	initProvincialProfiles();

	cga2026_script_vars.page_initialized = true;
};

const initOrientationMonitor = () => {

	const debounce_scrolling = debounce( doWhenScrolling, 10 );
	const debounce_screen_orientation = debounce( doWhenOrientationChanged, 50 );

	document.addEventListener( 'scroll', debounce_scrolling );
	addEventListener( 'resize', debounce_screen_orientation );
	addEventListener( 'orientationchange', debounce_screen_orientation );

	doWhenOrientationChanged();
};

const initPage = () => {
	window.cga2026_script_vars = window.cga2026_script_vars || {};
	deleteEmptyP();
	detectTouchDevice();
	initOrientationMonitor();
};


const initFrontScript = () => {

	if ( document.readyState !== 'loading' ) {
		initPage();
	} else {
		document.addEventListener( 'DOMContentLoaded', initPage );
	}

};

export default initFrontScript;